{
  "Sign In - EventLive": "Entrar - EventLive",
  "Forgot Password - EventLive": "Esqueci a senha - EventLive",
  "Password Restore Link Sent - EventLive": "Link de recuperação de senha enviado - EventLive",
  "Event": "Evento",
  "Event Details": "Detalhes do evento",
  "Details": "Detalhes",
  "How to Go Live": "Como transmitir ao vivo",
  "Multi-Camera": "Multicâmera",
  "Add a room": "Adicionar uma sala",
  "Guest List": "Lista de convidados",
  "Import Guests": "Importar convidados",
  "Add a Guest": "Adicionar um convidado",
  "Event Analytics": "Estatísticas do evento",
  "Purchase Successful": "Compra concluída",
  "Test EventLive": "Testar o EventLive",
  "Schedule Event": "Agendar evento",
  "Download everything": "Baixar tudo",
  "Update Email": "Atualizar e-mail",
  "Help Us Grow": "Ajude-nos a crescer",
  "Set a New Password - EventLive": "Criar uma nova senha - EventLive",
  "Are you sure?": "Tem certeza?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "Não foi possível carregar os dados. Verifique sua conexão com a internet. Confira se o fuso horário, a data e a hora do seu dispositivo estão corretos.",
  "Couldn't save your profile": "Não foi possível salvar seu perfil",
  "Link required": "O link é obrigatório",
  "Overview": "Visão geral",
  "{days}-Day Event: {start} – {end}": "Evento de {days} dias: {start} – {end}",
  "Close event": "Fechar evento",
  "This sign-in link has expired": "Este link de acesso expirou",
  "Couldn't sign you in from this link": "Não foi possível entrar com este link",
  "Please sign in to continue.": "Entre na sua conta para continuar.",
  "Couldn't save your changes": "Não foi possível salvar suas alterações",
  "TEST": "TESTE",
  "Download EventLive for Mac": "Baixar o EventLive para Mac",
  "Download for": "Baixar para",
  "People": "Pessoas",
  "Team invite - EventLive": "Convite para a equipe - EventLive"
}
